import { Link } from 'react-router-dom'
import { useStatusTracks, useStatusTracksByConfiguration } from '@/features/contract/statuses/hooks'
import { DualListPicker } from '@/components/common/DualListPicker'
import { useSetConfigurationStatusTracks } from '../hooks'

export function TracksPanel({ configurationCode }: { configurationCode: string }) {
  const allQ = useStatusTracks(false)
  const productQ = useStatusTracksByConfiguration(configurationCode, false)
  const setTracks = useSetConfigurationStatusTracks(configurationCode)

  if (allQ.isLoading) return <div>Ładowanie torów...</div>
  if (!allQ.data) return null

  const all = allQ.data
  const selected = productQ.data ?? []
  const selectedIds = new Set(selected.map(t => t.id))
  const available = all.filter(t => !selectedIds.has(t.id))

  return (
    <div className="flex flex-col gap-3 text-sm">
      <p className="text-xs text-slate-500">
        Przeciągnij tory, które ma śledzić ten produkt z lewego panelu na prawy. Kolejność na prawym panelu = kolejność wyświetlania.
        Tory są współdzielone - definiujesz je raz w{' '}
        <Link to="/settings/status-tracks" className="text-sky-700 underline">Tory statusów</Link>.
      </p>

      <DualListPicker
        available={available}
        selected={selected}
        getId={t => t.id}
        renderItem={t => (
          <div className="flex items-baseline gap-2">
            <span>{t.labelPl}</span>
            <span className="font-mono text-[10px] text-slate-400">{t.code}</span>
          </div>
        )}
        onChange={ids => setTracks.mutate(ids.map(Number))}
        availableLabel="Dostępne tory"
        selectedLabel="Aktywne w tym produkcie"
        emptyAvailable={
          all.length === 0 ? (
            <span>
              Brak globalnych torów - dodaj w{' '}
              <Link to="/settings/status-tracks" className="text-sky-700 underline">Tory statusów</Link>.
            </span>
          ) : (
            <span>Wszystkie tory są podpięte</span>
          )
        }
        emptySelected={<span>Przeciągnij tory tutaj</span>}
      />
    </div>
  )
}
